exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-plan-chooser{display:flex;flex-direction:row;justify-content:center;min-width:215px;width:100%}.subscription-plan-chooser--theme-dark{background-color:#333;border-radius:8px;color:#fff;padding:15px}@media (max-width: 639px){.subscription-plan-chooser--theme-dark{border-radius:0;width:100vw}}.subscription-plan-chooser__wrapper{display:flex;flex-direction:column;max-width:400px}.subscription-plan-chooser__button-wrapper{min-height:33px}.subscription-plan-chooser__grid{min-height:180px}\n", ""]);

// exports
exports.locals = {
	"subscription-plan-chooser": "subscription-plan-chooser",
	"subscription-plan-chooser--theme-dark": "subscription-plan-chooser--theme-dark",
	"subscription-plan-chooser__wrapper": "subscription-plan-chooser__wrapper",
	"subscription-plan-chooser__button-wrapper": "subscription-plan-chooser__button-wrapper",
	"subscription-plan-chooser__grid": "subscription-plan-chooser__grid"
};